import $ from "jquery"

export default {
  init(selector, config) {
    
  },
  finalize() {
    $('#logoAndNav').hide();

    $(window).bind("pageshow", function() {

      $('#occupation option').each(function() {
          if ( $(this).val() != '' ) {
              $(this).prop('selected', false);
          }
      });

      $('#workplacesetting option').each(function() {
          if ( $(this).val() != '' ) {
              $(this).prop('selected', false);
          }
      });

      $('#interests option').each(function() {
          if ( $(this).val() != '' ) {
              $(this).prop('selected', false);
          }
      });

      $('#levelofknowledge option').each(function() {
          if ( $(this).val() != '' ) {
              $(this).prop('selected', false);
          }
      });

        $('#state option').each(function() {
            if ( $(this).val() != '' ) {
                $(this).prop('selected', false);
            }
        });
  });

    $("#stepOneButton").click(function () {
        $("#selectStepOne").hide();
        $("#selectStepThree").show();       
    });

    $("#interests").change(function(){
        var len = $("select[name='interests[]'] option:selected").length;
        if(len > 1){
            $("#interests option[value='']").prop('selected', false);
        }
        if(len == 0){
            $("#interests option[value='']").prop('selected', true);
        }
    });

    $("#levelofknowledge").change(function(){
      var len = $("select[name='levelofknowledge[]'] option:selected").length;
      if(len > 1){
          $("#levelofknowledge option[value='']").prop('selected', false);
      }
      if(len == 0){
        $("#levelofknowledge option[value='']").prop('selected', true);
    }
  });

    $("#state").change(function(){
        var len = $("select[name='state[]'] option:selected").length;
        if(len > 1){
            $("#state option[value='']").prop('selected', false);
        }
        if(len == 0){
            $("#state option[value='']").prop('selected', true);
        }
    });
  
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/lp-search.js